<template>
    <div id="modelDetail" :class="$root.isMob() ? 'mob' : ''" :style="$route.path=='/usercenter'&&$root.isMob()?'padding: 20px;margin-top: 60px;':''">
        <h2 class="title">模型详情</h2>
        <div class="top">
            <div class="left">
                <div class="name" v-if="$root.isMob()">{{ data?.name }}</div>
                <div class="preImgBox">
                    <el-image 
                    :style="currentImg==''?'width:100%':''"
                    fit="contain"
                    :src="currentImg"
                    :preview-src-list="photos">
                        <el-empty description="暂无图片" slot="error" class="image-slot"></el-empty>
                    </el-image>
                </div>

                <ul class="imgList" @mouseenter="scrollImgList(true,'imgList')">
                    <li v-for="(item,key) in photos" :key="key+'_'+item" @click="changeImg(item)">
                        <img class="preImg" :src="item"/>
                    </li>
                    <div class="empty" v-if="photos.length==0">没有更多图片了</div>
                </ul>
            </div>
            <div class="right">
                <div class="name" v-if="!$root.isMob()">{{ data?.name }}</div>
                <div v-if="data.content" class="content" v-html="data?.content"></div>
                <div v-if="!data.content" class="content">
                    <el-empty description="暂无描述"></el-empty>
                </div>
                <div class="btnGroup">
                    <el-button type="primary" @click="openAlert">立即下载</el-button>
                    <i class="downloadBtn el-icon-download" @click="openAlert"></i>
                </div>
            </div>
        </div>
        <h2 class="title">相关模型</h2>
        <div class="bottom">            
            <div class="item" v-for="(item,key) in randomData" :key="'random_'+key+'_'+item.id" @click="gotoDetail(item.id)">
                <img v-if="item.photos" :src="getFirstPhoto(item.photos)" />
                <div class="empty" v-if="!item.photos">
                    暂无图片
                </div>
                <div class="name">{{ item.name }}</div>
            </div>
        </div>        
    </div>
</template>

<script>
import axios from 'axios';
import Service from '@/assets/img/service.png';

export default {
    name: 'modelDetail',
    props: {
        id: {
            type: String,
            default: '-1'
        }
    },
    data() {
        return {
            imgService:Service,
            API:window.config.api,
            data: {},
            randomData:[],
            photos:[],
            currentImg:"",
        }
    },
    watch: {
        "id":function() { 
            this.currentImg = "";
            this.getData();
            this.getAboutData();
        }
    },
    methods: {
        openAlert(){
            let html = document.createElement('div');
            let qrcode = document.createElement('div');
            let url = this.data.link_url;
            qrcode.style = "margin-bottom: 20px;display: flex;flex-direction: column;align-items: center;justify-content: center;";
            qrcode.innerHTML = '<img src="'+this.imgService+'">人工客服二维码';
            let text = document.createElement('div');
            text.className = "text";
            text.innerHTML = this.linkUrl != ""?'请前往模型站下载或联系人工客服获取':'请联系人工客服获取';
            html.appendChild(qrcode);
            html.appendChild(text);
            let btnText = url == ""?'我知道了':'去下载'
            let title = url == ""?'提示':'前往下载'
            this.$alert(html.innerHTML, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: btnText,
                center: true,
                callback: (action) => {                     
                    if(url != "" && action == "confirm"){
                        window.open(this.linkUrl,"_blank");
                    }
                }
            });
        },
        async getData() {
            this.$root.goTop();
            let id = this.id;
            if(id != -1){
                try{
                    let res = await axios.get(window.config.api+'index.php/api/model/detail?id='+id,)
                    let data = res.data;                    
                    if(data.code == 1){
                        this.data = data.data;
                        //解析数据S
                        this.photos = [];
                        if(this.data.photos){      
                            let photos = this.data.photos.split(',');            
                            photos.forEach(item => {
                                this.photos.push(this.API+item)
                            });
                        }
                        
                        if(this.photos.length > 0){
                            this.currentImg = this.photos[0];
                        }
                        //解析数据E
                    }
                    else{
                        if(data.code == 401){
                            this.$root.netError(data)
                            return false;
                        }
                        this.$notify({
                            type: 'error',
                            title: '错误',
                            message: data.msg
                        });
                    }
                    return false;
                }
                catch(e){
                    this.$root.netError(e);
                    return false;
                }
            }
        },
        async getAboutData() {
            try{
                let res = await axios.get(window.config.api+'index.php/api/model/randomList?except='+this.id)
                let data = res.data;                    
                if(data.code == 1){
                    this.randomData = data.data;
                }
                else{
                    if(data.code == 401){
                        this.$root.netError(data)
                        return false;
                    }
                    this.$notify({
                        type: 'error',
                        title: '错误',
                        message: data.msg
                    });
                }
                return false;
            }
            catch(e){
                this.$root.netError(e);
                return false;
            }
        },
        changeImg(url){
            this.currentImg = url;
        },
        // 切换滚动方向
        scrollImgList(status,className) {            
            const container = document.getElementsByClassName(className);
            console.log('enter',container);
            if (status) {
                for(let i=0;i<container.length;i++){
                    container[i].addEventListener('wheel', this.handleWheelHorizontal);
                }                
            } else {
                for(let i=0;i<container.length;i++){
                    container[i].removeEventListener('wheel', this.handleWheelHorizontal);
                }                
            }
        },
        // 横向滚动处理
        handleWheelHorizontal(e) {
            // 阻止默认的纵向滚动行为
            e.preventDefault();
            e.stopPropagation();

            // 根据滚轮的 delta 值来调整横向滚动
            const container = e.currentTarget;
            container.scrollLeft += e.deltaY/2;
        },
        getFirstPhoto(photos){
            if(photos && photos.length>0){
                return this.API+photos.split(",")[0];
            }
            return null;
        },
        gotoDetail(id){
            if(this.$route.query?.id==id){
                return;
            }
            if(this.$route.path != '/usercenter'){
                this.$router.replace({
                    path:"/modelDetail",
                    query:{
                        id:id
                    }
                })
            }
            else{
                this.$emit('changeId',id);
            }
        },
    },
    created(){ 
        this.getData();
        this.getAboutData();
    },
}
</script>

<style scoped lang="scss" src="@/assets/css/lib/modelDetail.scss"></style>